import React, { Component } from 'react';
import icon04 from '../upload/imgs/icon04.png';

class TableEmpty extends Component {
  render() {
    return (
      <>
        <p className="empty-image">
          <img src={icon04} alt="" />
        </p>
        <p className="empty-text">暂无数据</p>
      </>
    );
  }
}

export default TableEmpty;
